import { gql } from '@apollo/client';

// 根据运单号查询计费信息输入类型
export interface QueryPricingByTrackingNumberInput {
    trackingNumber: string;
    pricingNodeCode?: string | null;
}

// 定价结果类型
export interface PricingResultType {
    id: string | null;
    businessCode: number;
    businessScenarioCode: number;
    businessFeeCode: string;
    pricingAt: string;
    businessAt: string;
    businessId: string;
    amount: number;
    clientId: number | null;
    otherBusinessId: string | null;
    billingContentJson: string | null;
    isSuccess: boolean;
    pricingNodeCode: string | null;
    pricingErrorCode: string | null;
}

// 查询结果类型
export interface QueryPricingResult {
    success: boolean;
    message: string;
    data: PricingResultType[];
    totalCount: number;
    nextCursor?: string | null;
}

// 根据运单号查询计费信息
export const QUERY_PRICING_BY_TRACKING_NUMBER = gql`
    query QueryPricingByTrackingNumber($input: QueryPricingByTrackingNumberInput!) {
        queryPricingByTrackingNumber(input: $input) {
            success
            message
            data {
                id
                businessCode
                businessScenarioCode
                businessFeeCode
                pricingAt
                businessAt
                businessId
                amount
                clientId
                otherBusinessId
                billingContentJson
                isSuccess
                pricingNodeCode
                pricingErrorCode
            }
            totalCount
        }
    }
`;

// 按条件分页查询计费结果（不返回 billingContentJson）
export interface QueryPricingByConditionInput {
    /** 客户 ID 列表；不传或空表示不按客户筛选 */
    clientIds?: number[] | null;
    businessAtStart?: string | null;
    businessAtEnd?: string | null;
    pricingErrorCode?: string | null;
    pricingNodeCode?: string | null;
    businessScenarioCode?: number | null;
    isSuccess?: boolean | null;
    page?: number;
    pageSize?: number;
    cursor?: string | null;
    batchPages?: number;
}

export const QUERY_PRICING_BY_CONDITION = gql`
    query QueryPricingByCondition($input: QueryPricingByConditionInput!) {
        queryPricingByCondition(input: $input) {
            success
            message
            data {
                id
                businessCode
                businessScenarioCode
                businessFeeCode
                pricingAt
                businessAt
                businessId
                amount
                clientId
                otherBusinessId
                isSuccess
                pricingNodeCode
                pricingErrorCode
            }
            totalCount
            nextCursor
        }
    }
`;

// 计费失败错误码选项
export interface FailPricingResultErrorCodeType {
    code: string;
    message: string;
}

export const GET_ALL_FAIL_PRICING_RESULT_ERROR_CODES = gql`
    query GetAllFailPricingResultErrorCodes {
        getAllFailPricingResultErrorCodes {
            code
            message
        }
    }
`;

// 结算用户角色类型选项
export interface SettlementClientRoleTypeEnumType {
    code: number;
    description: string;
}

export const GET_ALL_SETTLEMENT_CLIENT_ROLE_TYPE_ENUMS = gql`
    query GetAllSettlementClientRoleTypeEnums {
        getAllSettlementClientRoleTypeEnums {
            code
            description
        }
    }
`;

// 响应类型定义
export interface QueryPricingByTrackingNumberResponse {
    queryPricingByTrackingNumber: QueryPricingResult;
}

export interface QueryPricingByConditionResponse {
    queryPricingByCondition: QueryPricingResult;
}

export interface GetAllFailPricingResultErrorCodesResponse {
    getAllFailPricingResultErrorCodes: FailPricingResultErrorCodeType[];
}

export interface GetAllSettlementClientRoleTypeEnumsResponse {
    getAllSettlementClientRoleTypeEnums: SettlementClientRoleTypeEnumType[];
}

// 变量类型定义
export interface QueryPricingByTrackingNumberVariables {
    input: QueryPricingByTrackingNumberInput;
}

export interface QueryPricingByConditionVariables {
    input: QueryPricingByConditionInput;
}
